/* @flow */
import Cookies from 'lib/Cookies';
import FileDropzoneMixinSupport from 'lib/FileDropzoneMixinSupport.js';

import _ from 'lodash';

const mixin = {
  handleAddedFile(file) {
    file.key = _.uniqueId();

    this.state.fileData[file.key] = { type: file.type };
    this.setState({ files: this.state.files.concat(file) });

    if (this.onAddedFile) {
      this.onAddedFile(file);
    }
  },

  handleRemovedFile(file) {
    const fileIndex = this.state.files.indexOf(file);
    this.state.files.splice(fileIndex, 1);
    delete this.state.fileData[file.key];
    this.setState({
      files: this.state.files,
      fileData: this.state.fileData,
    });
  },

  handleUploadProgress(file, progress /* , bytesSent */) {
    this.state.fileData[file.key].progress = progress;
    this.setState({ fileData: this.state.fileData });
  },

  handleUploadSuccess(file) {
    if (this.onUploadSuccess) {
      this.onUploadSuccess(file);
    }
  },

  handleSendingFile(file, xhr) {
    const csrfToken = Cookies.get('csrf_token');
    if (csrfToken) {
      xhr.setRequestHeader('X-CSRF-Token', csrfToken);
    }
  },

  handleUploadError(file, error) {
    // A second file is attempting to be uploaded
    if (this.state.files.length > 1) {
      this.removeFile(file);
      return;
    }

    console.warn('Upload Error', error);
    this.state.fileData[file.key].error = error;
    this.setState({ fileData: this.state.fileData });
    if (this.onUploadFailed) {
      this.onUploadFailed(file, error);
    }
  },
};

const FileSenderMixin = Object.assign(mixin, FileDropzoneMixinSupport);

export default FileSenderMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/FileSenderMixin.js